import React from 'react'
import LeaderboardScreenCopyTableContainer from '@feature/leaderboard/pages/ScreenCopyLeader/LeaderboardScreenCopyTableContainer'
import LeaderboardOptionContainer from '@feature/leaderboard/pages/ScreenCopyLeader/LeaderHeaders/LeaderboardOptionContainer'
import useScreenLog from '@hook/useScreenLog'

const LeaderboardScreenCopyLeader = () => {
    const {} = useScreenLog({pageName: 'leaderboard_copyleader'})
    return (
        <div>
            <LeaderboardOptionContainer />
            <LeaderboardScreenCopyTableContainer />
        </div>
    )
}

export default LeaderboardScreenCopyLeader
